import type { Theme } from '@emotion/react'

import type { DeepPurple } from './themes'

type GradientVariants = 'linearGray'

export const getGradient = (
  theme: Theme,
  gradient: GradientVariants,
  variant: keyof DeepPurple = 100
) => {
  const gradients = {
    linearGray: {
      [variant]: `linear-gradient(90deg, transparent 0%, ${theme.palette.deepPurple[variant]} 100%)`,
    },
  }

  return gradients[gradient][variant]
}
